import { Component, OnInit, Input } from '@angular/core';
import { map } from 'rxjs';
import { Router } from '@angular/router';
import { select } from 'src/app/common/utilities/ngxs-utils';
import { UserState } from 'src/app/common/state/user/user.state';
import { User } from 'src/app/common/state/user/user.model';
import {
  LibraryShelfItemModelDTO,
  LibraryShelfModelDTO,
  ResourceOnlineCourseDTO,
} from '../../../dtos/resources.dto';
import { ResourcesBookmarkService } from '../../../services/resources/resources-bookmark.service';

@Component({
  selector: 'app-item-shelves-bookmark',
  templateUrl: './item-shelves-bookmark.component.html',
  styleUrls: ['./item-shelves-bookmark.component.scss'],
})
export class ItemShelvesBookmarkComponent implements OnInit {
  @Input() itemId: number;

  @Input() itemType: string;

  @Input() itemOnAShelf = 0;

  user$ = select(UserState.getUser);

  currentUser: User | null = null;

  myShelves: LibraryShelfModelDTO[] = [];

  emptyShelf = false;

  newShelf = {} as LibraryShelfModelDTO;

  newShelfItem = {} as LibraryShelfItemModelDTO;

  childShelf: LibraryShelfModelDTO | null;

  childLoading = false;

  nameShelf = false;

  savingNewShelf = false;

  constructor(
    private router: Router,
    private resourcesBookmarkService: ResourcesBookmarkService
  ) {
    this.user$
      .pipe(
        map((user) => {
          this.currentUser = user;
        })
      )
      .subscribe();
  }

  ngOnInit() {
    this.newShelf.title = '';
    this.newShelfItem.ref_table = this.itemType;
    this.newShelfItem.ref_table_id = this.itemId;
  }

  getMyShelfs() {
    this.resourcesBookmarkService
      .getMyShelves(this.itemType, this.itemId)
      .subscribe((response) => {
        if (response.items) {
          this.myShelves = response.items;
          if (this.myShelves.length === 0) {
            this.emptyShelf = true;
          } else {
            this.emptyShelf = false;
          }
        } else {
          this.myShelves = [];
        }
      });
  }

  updateStatus() {
    if (this.itemType === 'elearn_resource') {
      this.updateResourceStatus();
    } else if (this.itemType === 'elearn_vpl_course') {
      this.updateCourseStatus();
    } else {
      // TODO: Is this really the only error we want to throw? Maybe throwing something for Sentry so we're aware of it?
    }
  }

  updateResourceStatus() {
    this.resourcesBookmarkService
      .updateResourceStatus(this.itemId)
      .subscribe((response) => {
        if (response.item) {
          this.itemOnAShelf = response.item.isOnUsersShelf;
          if (this.itemOnAShelf <= 0) {
            this.removeChildShelf();
          } else {
            this.getChildShelf(this.itemOnAShelf);
          }
        }
      });
  }

  updateCourseStatus() {
    this.resourcesBookmarkService.getOnlineCourses().subscribe((result) => {
      if (result.items) {
        const selectedCourse = result.items.find(
          (item: ResourceOnlineCourseDTO) => item.id === this.itemId
        );
        this.itemOnAShelf = selectedCourse.isOnUsersShelf;
        if (this.itemOnAShelf <= 0) {
          this.removeChildShelf();
        } else {
          this.getChildShelf(this.itemOnAShelf);
        }
      }
    });
  }

  getChildShelf(shelfId: number) {
    this.childLoading = true;
    this.resourcesBookmarkService
      .getChildShelf(this.itemType, this.itemId, shelfId)
      .subscribe((response) => {
        if (response.item) {
          this.childShelf = response.item;
          this.newShelf.parent_shelf_id = this.childShelf?.id;
          this.childLoading = false;
        } else {
          this.childShelf = null;
          this.childLoading = false;
        }
      });
  }

  removeChildShelf() {
    this.childShelf = null;
    this.newShelf.title = '';
    this.nameShelf = false;
    delete this.newShelf.parent_shelf_id;
  }

  createShelf() {
    this.nameShelf = false;
    this.savingNewShelf = true;
    if (this.newShelf.title === '') {
      this.newShelf.title = 'New Shelf';
    }
    this.resourcesBookmarkService
      .createShelf(this.newShelf)
      .subscribe((response) => {
        if (response.item) {
          this.savingNewShelf = false;
          if (this.childShelf) {
            this.childShelf.childShelves?.push(response.item);
          } else {
            this.myShelves.push(response.item);
          }
          this.toggleFavorite(response.item);
        }
        this.newShelf.title = '';
      });
  }

  saveTitle(shelf: LibraryShelfModelDTO) {
    this.resourcesBookmarkService
      .updateShelfTitle(shelf.id, shelf.title)
      .subscribe();
  }

  toggleFavorite(shelf: LibraryShelfModelDTO) {
    if (!shelf.has_current_item) {
      this.newShelfItem.elearn_favorite_shelf_id = shelf.id;
      this.resourcesBookmarkService
        .addFavoriteShelf(shelf.id, this.newShelfItem)
        .subscribe((result) => {
          if (result) {
            shelf.has_current_item = true;
            shelf.is_active = true;
            this.updateStatus();
          }
        });
    } else {
      this.resourcesBookmarkService
        .removeFavoriteShelf(shelf.id, this.itemType, this.itemId)
        .subscribe((result) => {
          if (result) {
            shelf.has_current_item = false;
            shelf.is_active = false;
            this.updateStatus();
          }
        });
    }
  }

  gotoMyLibrary() {
    this.router.navigate(['/resources/my']);
  }

  gotoShelf(shelf: LibraryShelfModelDTO) {
    this.router.navigate([`/resources/my/shelf/${shelf.id}`]);
  }
}
